import { ReactNode } from 'react';
import {
  PlayerPortalsFooter,
  PlayerPortalsFooterProps,
  PlayerPortalsHeader,
  PlayerPortalsHeaderProps,
} from '../../../PlayerPortals';

import styles from './PlayerPortalsPageTemplate.module.scss';

type PlayerPortalsPageTemplateProps = {
  children?: ReactNode | ReactNode[];
  header?: PlayerPortalsHeaderProps;
  footer?: PlayerPortalsFooterProps;
};

export const PlayerPortalsPageTemplate = ({
  children,
  header,
  footer = undefined,
}: PlayerPortalsPageTemplateProps) => {
  return (
    <div data-testid="PageTemplate" className={styles.wrapper}>
      <PlayerPortalsHeader {...header} />
      {children}
      <PlayerPortalsFooter {...footer} />
    </div>
  );
};
